module.exports = __webpack_public_path__ + "static/media/nanci_oliveira.2348af8a.png";